const XLSX_MIME =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

/**
 * Triggers a browser download of the given binary data under `filename` by
 * creating a temporary object URL and clicking a hidden anchor.
 */
const triggerBrowserDownload = (data: ArrayBuffer, filename: string): void => {
  const blob = new Blob([data], { type: XLSX_MIME });
  const url = URL.createObjectURL(blob);

  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  URL.revokeObjectURL(url);
};

export default triggerBrowserDownload;
